module.exports = __webpack_public_path__ + "static/Repl-b8ac8361c21fd81668b5cb0bb0e77343.png";